module.exports = __webpack_public_path__ + "static/media/tracking_icon.3c58924d.png";